import { NewReservationInfo } from '../../newReservation/components/NewReservationPanel/types';
import { TimelineUrlParams, TimelineUrlParamsKeys } from '../schemas/timelineUrlParamsSchema';

export const getNewReservationInfoFromSearchParams = (
    searchParams: TimelineUrlParams
): NewReservationInfo | undefined =>
    searchParams[TimelineUrlParamsKeys.NewReservationStartUtc] &&
    searchParams[TimelineUrlParamsKeys.NewReservationEndUtc] &&
    searchParams[TimelineUrlParamsKeys.NewReservationResourceId] &&
    searchParams[TimelineUrlParamsKeys.NewReservationResourceCategoryId]
        ? {
              startUtc: searchParams[TimelineUrlParamsKeys.NewReservationStartUtc],
              endUtc: searchParams[TimelineUrlParamsKeys.NewReservationEndUtc],
              resourceId: searchParams[TimelineUrlParamsKeys.NewReservationResourceId],
              resourceCategoryId: searchParams[TimelineUrlParamsKeys.NewReservationResourceCategoryId],
          }
        : undefined;
